export enum CodeDataset {
    Css = "css",
    CustomCode = "customCode"
}
